'use client';
import styled from 'styled-components';
import { useEffect, useRef } from 'react';
import { NavigationMenu } from '@/entities/navigation-menu/NavigationMenu';
import { fetcherWithToken } from '@/shared/api/fetcher';
import useSWR from 'swr';
import { useIsAuth, useUserCurrency } from '@/shared/providers/user-provider/use-user';
import { useCurrentLocale } from '@locales/client';
import { WRAPPER } from '@/shared/styles/themes';
import { Condition } from '@/shared/ui/condition/condition';
import AuthButtons from '@/shared/ui/auth-buttons';
import { useRouter, useSearchParams } from 'next/navigation';
import { getBrandData } from '@/shared/hooks/useBrandTheme';
import { useViewMenu } from '@/shared/hooks/useViewMenu';
import { useConfigureAppShell } from '@/widgets/layouts/app-shell-config-context';

export const Betting = () => {
  useConfigureAppShell({ flexMain: true, hideFooter: true });
  const iframeRef = useRef(null);
  const isAuth = useIsAuth();
  const currency = useUserCurrency();
  const bettingEnabled = getBrandData().brandTheme.features.betting;
  const { isViewMenu } = useViewMenu();
  const language = useCurrentLocale();
  const searchParams = useSearchParams();
  const router = useRouter();
  // const isDevelop = isDevBuild();
  const host = process.env.NEXT_PUBLIC_BETTING_URL;
  // const host = isDevelop
  //   ? 'pingwincasino.phoenix365-prod.com' //test
  //   : 'pingwinprod.phoenix365-prod.com'; //prod

  const { data, isLoading } = useSWR(
    isAuth && bettingEnabled ? '/bettingToken' : null,
    fetcherWithToken
  );
  useEffect(() => {
    if (!bettingEnabled) {
      router.push('/');
    }
  }, [bettingEnabled, router]);

  if (isLoading || !bettingEnabled) return null;

  const page = searchParams.get('page') ?? 'sport';

  let lang = language === 'uk' ? 'ua' : language;
  switch (lang) {
    case 'kz':
      lang = 'en';
      break;
  }
  const url = data
    ? `https://${host}/${lang}/${page}?authToken=${data}&currency=${currency}`
    : `https://${host}/${lang}/${page}`;

  const handleIframeLoad = () => {
    const app = iframeRef.current.contentWindow;
    app.postMessage({ action: 'set_lang', lang: lang }, '*');
    if (page) {
      app.postMessage({ action: 'redirect', url: `/${lang}/${page}` }, '*');
      // app.postMessage({ action: 'redirect', url: `/event/2240479` }, '*');
    }
    app.postMessage({ action: 'set_currency', currency: currency }, '*');
  };

  return (
    <Wrapper $isViewMenu={isViewMenu}>
      <Space />
      <Condition match={!isAuth}>
        <AuthButtons />
      </Condition>

      <BannersWrapper $isViewMenu={isViewMenu}>
        <NavigationMenu menu={'betting'} />
      </BannersWrapper>
      {/*<Wrapper>*/}
      <StyledIframeContainer>
        <StyledIframe
          ref={iframeRef}
          src={url}
          title="Betting"
          id="betting"
          onLoad={handleIframeLoad}
        />
      </StyledIframeContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $isViewMenu?: boolean }>`
  ${WRAPPER}
  width: 100%;
  max-width: 100%;
  margin: -16px 0 16px 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  height: calc(100dvh - 64px);
  gap: ${props => props.$isViewMenu ? '0' : '12px'};
  
  @media (max-width: 768px) {
    flex: 1;
    margin: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

const StyledIframeContainer = styled.div`
  width: 100%;
  container-type: inline-size;
  flex: 1;
  display: flex;
  box-sizing: border-box;
  // margin-left: 20px;

  //   @media (max-width: 768px) {
  //     margin-left: 0;
  //   }
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  margin: 0 0 16px 0;
`;

const Space = styled.div`
  margin: 16px 0;
  @media (max-width: 768px) {
    margin: 0;
  }
`;

const BannersWrapper = styled.div<{ $isViewMenu?: boolean }>`
  display: ${props => props.$isViewMenu ? 'none' : 'auto'};
  ${WRAPPER}
  
  @media (max-width: 768px) {
    margin: 0;
  }
  @media (min-width: 769px) {
    width: 100%;
  }
`;
